import { LevelPlayThisOrThat as Activity } from '.'

export const SLUG = 'this_or_that'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'verify',
    waitValidation: true
  },
  handleAnswerCallback: props => {
    let { answer, activity } = props
    let { save_answer: saveAnswer, associations = [] } = activity.meta
    const correctAssociation = associations.find(
      association => association?.is_correct
    )

    let answerIsCorrect = answer == correctAssociation.name

    return { answer, answerIsCorrect, skipValidation: saveAnswer }
  },
  Component: Activity
}
